import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import contactImg from "../assets/img/contact-img.svg";
import "animate.css";
import TrackVisibility from "react-on-screen";
import Alert from "react-bootstrap/Alert";
const bakendURL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

export const Contact = () => {
  const formInitialDetails = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  };
  const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("Send");
  const [status, setStatus] = useState({});
  const [errors, setErrors] = useState({});

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formDetails.firstName) newErrors.firstName = "First Name is required";
    if (!formDetails.lastName) newErrors.lastName = "Last Name is required";
    if (!formDetails.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formDetails.email)) {
      newErrors.email = "Email is invalid";
    }
    // if (!formDetails.phone) {
    //   newErrors.phone = "Phone Number is required";
    // } else if (!/^\d+$/.test(formDetails.phone)) {
    //   newErrors.phone = "Phone Number must be numeric";
    // }
    if (!formDetails.message) newErrors.message = "Message is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return; // Stop if the form is invalid

    setButtonText("Sending...");
    let response = await fetch(bakendURL + "/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(formDetails),
    });
    setButtonText("Send");
    let result = await response.json();
    setFormDetails(formInitialDetails);
    if (result.code === 200) {
      setStatus({ succes: true, message: "Message sent successfully" });
    } else {
      setStatus({
        succes: false,
        message: "Something went wrong, please try again later.",
      });
    }
  };

  return (
    <section className="contact px-3" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? "animate__animated animate__zoomIn" : ""
                  }
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Get In Touch</h2>
                  <form onSubmit={handleSubmit}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.firstName}
                          placeholder="First Name*"
                          onChange={(e) =>
                            onFormUpdate("firstName", e.target.value)
                          }
                        />
                        {errors.firstName && (
                          <p className="danger">{errors.firstName}</p>
                        )}
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          value={formDetails.lastName}
                          placeholder="Last Name*"
                          onChange={(e) =>
                            onFormUpdate("lastName", e.target.value)
                          }
                        />
                        {errors.lastName && (
                          <p className="danger">{errors.lastName}</p>
                        )}
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="email"
                          value={formDetails.email}
                          placeholder="Email Address*"
                          onChange={(e) =>
                            onFormUpdate("email", e.target.value)
                          }
                        />
                        {errors.email && (
                          <p className="danger">{errors.email}</p>
                        )}
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="tel"
                          value={formDetails.phone}
                          placeholder="Phone No."
                          onChange={(e) =>
                            onFormUpdate("phone", e.target.value)
                          }
                        />
                        {/* {errors.phone && (
                          <p className="danger">{errors.phone}</p>
                        )} */}
                      </Col>
                      <Col size={12} className="px-1">
                        <textarea
                          rows="3"
                          value={formDetails.message}
                          placeholder="Message*"
                          onChange={(e) =>
                            onFormUpdate("message", e.target.value)
                          }
                        ></textarea>
                        {errors.message && (
                          <p className="danger">{errors.message}</p>
                        )}

                        {status.message && (
                          <Col>
                            <Alert
                              variant={
                                status.success === false ? "danger" : "success"
                              }
                            >
                              {status.message}
                            </Alert>
                            {/* <p className={status.success === false ? "danger" : "success"}>{status.message}</p> */}
                          </Col>
                        )}
                        <button type="submit">
                          <span>{buttonText}</span>
                        </button>
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
